module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-4.dea320a.woff2";